import { render } from "./family_planning.vue?vue&type=template&id=db836006&scoped=true"
import script from "./family_planning.vue?vue&type=script&lang=js"
export * from "./family_planning.vue?vue&type=script&lang=js"

import "./family_planning.vue?vue&type=style&index=0&id=db836006&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db836006"]])

export default __exports__